<template>
    <div class="card mt-4">
      <table class="table m-0">
        <thead>
          <tr>
            <th scope="col">Feed Type Id</th>
            <th scope="col">Title</th>
            <th scope="col">Description</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!loading"  v-for="{ id, title, description, typeId } in feedTypes" :key="id">
            <td>{{ typeId }}</td>
            <td>{{ title }}</td>
            <td>{{ description }}</td>
            <td>
              <router-link :to="`/feedtype/edit/${id}`">
                <button class="btn btn-primary btn-sm me-2">
                  Edit
                </button>
              </router-link>
              <button class="btn btn-danger btn-sm" @click="deleteFeedTypeWrapper(id)">
                Delete
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </template>
  
<script>
import { useLoadFeedTypes, deleteFeedType } from '@/firebase'
export default {
  data() {
    return {
      loading: false,
      feedTypes: []
    }
  },
  created() {
    this.getFeedTypeList()
  },
  methods: {
    getFeedTypeList() {
      this.loading = true
      useLoadFeedTypes().then(response => {
        this.loading = false
        this.feedTypes = response
      })
      .catch(error => {
        this.loading = false
        console.log(error)
      })
    },
    deleteFeedTypeWrapper(id){
        deleteFeedType(id).then(()=>{
            this.getFeedTypeList()
        })
    }
  }
}

</script>